export enum TableStyleEnum {
  Striped = 1,
  None = 2,
}
